export const EMAIL_TABLE = "emails"
// `messageId` is a required body field on the `Email` type but stays unindexed
// here — `frontend/src/query/hooks/usePreOrders/offlineShim.ts` reads it from
// `.toArray()` row bodies to resolve per-user sibling emails in the recap
// source-icon. Removing `messageId` from the row write path would silently
// break that resolution; keep it on the sync payload.
export const EMAIL_TABLE_SCHEMA =
  "id, companyId, emailAccountId, userId, archived, read, emailDate, syncId"
